// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("public/img/dashboard.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.defaultWidgetFrame {
  background: #fff;
  border: 1px solid #e6e9ed;
  width: 100%;
  margin-bottom: 10px;
  padding: 10px 17px;
  display: inline-block;
  position: relative;
}

.defaultWidgetFrameHeader {
  border-bottom: 2px solid #e6e9ed;
  height: 35px;
  margin-bottom: 10px;
  padding: 1px 5px 6px;
}

.defaultWidgetFrameHeader .title {
  float: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
  display: block;
  overflow: hidden;
}

.defaultWidgetFrameHeader .remove {
  float: right;
  cursor: pointer;
  margin-top: 5px;
  font-size: 11px;
  text-decoration: none;
}

.droppable-column {
  background-color: #e7e7e7;
}

.dazzle-column-content-item-vertical {
  float: none;
  flex-direction: column;
  margin-bottom: 10px;
  display: flex;
}

.dazzle-column-content-item-horizontal {
  margin: 0 10px 10px;
  display: inline-block;
}

.dazzle-column-header {
  -webkit-user-select: auto;
  user-select: auto;
  border-bottom: 2px solid #f4f4f4;
  flex-direction: row;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  display: flex;
}

.dazzle-column-header.grab {
  cursor: grab;
}

@media (width >= 1200px) {
  .dazzle-col {
    flex-direction: column;
    display: flex;
  }
}

.dazzle__title-input {
  width: auto;
  height: 29px;
  padding-bottom: 4px;
}

.dazzle__row-row-wrapper--over {
  background: #ff323266;
}

.dazzle__row-row-wrapper--outline {
  outline: 1px dashed #dcdcdc;
}

.dazzle__row-content-wrapper {
  margin-bottom: 10px;
}

@media (width >= 1200px) {
  .dazzle__row-content-wrapper {
    margin-bottom: 25px;
    display: flex;
  }

  .dazzle__row-content-wrapper--editable {
    margin-bottom: 10px;
  }
}

.dazzle__empty-dashboard {
  text-align: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: top;
  background-repeat: no-repeat;
  background-size: 250px;
  padding: 250px 0 25px;
}

.dazzle__column-wrapper {
  border: 1px solid #f4f4f4;
  flex: auto;
  padding: 10px 17px;
}

.dazzle__column-title {
  margin-top: 5px;
  margin-bottom: 5px;
}

.dazzle__column-title.is-untitled {
  font-style: italic;
}

.dazzle__column-content {
  text-align: center;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 10px;
}

.dazzle__add-row-wrapper {
  cursor: pointer;
  background: #f4f4f4;
  border-radius: 3px;
  justify-content: stretch;
  align-items: stretch;
  height: 2.2rem;
  margin-top: 5px;
  margin-bottom: 5px;
  display: flex;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/containers/Dazzle/lib/style/style.css","webpack://./services/frontend/app/containers/Dazzle/lib/style/style.css"],"names":[],"mappings":"AADA;ECEE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kBAAkB;EAClB,yDAAiD;EACjD,wBAAwB;EACxB,4BAA4B;EAC5B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf","sourcesContent":[".defaultWidgetFrame {\n  position: relative;\n  width: 100%;\n  margin-bottom: 10px;\n  padding: 10px 17px;\n  display: inline-block;\n  background: #fff;\n  border: 1px solid #e6e9ed;\n}\n\n.defaultWidgetFrameHeader {\n  border-bottom: 2px solid #e6e9ed;\n  padding: 1px 5px 6px;\n  margin-bottom: 10px;\n  height: 35px;\n}\n\n.defaultWidgetFrameHeader .title {\n  font-size: 18px;\n  float: left;\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.defaultWidgetFrameHeader .remove {\n  float: right;\n  font-size: 11px;\n  cursor: pointer;\n  text-decoration: none;\n  margin-top: 5px;\n}\n\n.editable-column {\n  /* border: 1px dotted #8c8080;\n  padding: 10px; */\n}\n\n.droppable-column {\n  background-color: #e7e7e7;\n}\n\n.dazzle-column-content-item-vertical {\n  float: none;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n}\n\n.dazzle-column-content-item-horizontal {\n  display: inline-block;\n  margin: 0 10px 10px;\n}\n\n.dazzle-column-header {\n  align-items: center;\n  border-bottom: 2px solid #f4f4f4;\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  -webkit-user-select: auto;\n          user-select: auto;\n}\n\n.dazzle-column-header.grab {\n  cursor: grab;\n}\n\n@media (min-width: 1200px) {\n  .dazzle-col {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.dazzle__title-input {\n  height: 29px;\n  padding-bottom: 4px;\n  width: auto;\n}\n\n.dazzle__row-row-wrapper--over {\n  background: rgba(255, 50, 50, 0.4);\n}\n\n.dazzle__row-row-wrapper--outline {\n  outline: 1px dashed #dcdcdc;\n}\n\n.dazzle__row-content-wrapper {\n  margin-bottom: 10px;\n}\n\n@media (min-width: 1200px) {\n\n.dazzle__row-content-wrapper {\n    display: flex;\n    margin-bottom: 25px\n}\n\n.dazzle__row-content-wrapper--editable {\n    margin-bottom: 10px\n}\n  }\n\n.dazzle__empty-dashboard {\n  text-align: center;\n  background-image: url('public/img/dashboard.png');\n  background-repeat: no-repeat;\n  background-position: center top;\n  background-size: 250px;\n  padding: 250px 0 25px;\n}\n\n.dazzle__column-wrapper {\n  border: 1px solid #f4f4f4;\n  flex: 1;\n  flex-basis: auto;\n  padding: 10px 17px;\n}\n\n.dazzle__column-title {\n  margin-bottom: 5px;\n  margin-top: 5px;\n}\n\n.dazzle__column-title.is-untitled {\n    font-style: italic;\n  }\n\n.dazzle__column-content {\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 10px;\n  text-align: center;\n}\n\n.dazzle__add-row-wrapper {\n  align-items: stretch;\n  background: #f4f4f4;\n  border-radius: 3px;\n  cursor: pointer;\n  display: flex;\n  height: 2.2rem;\n  justify-content: stretch;\n  margin-bottom: 5px;\n  margin-top: 5px;\n}\n",".defaultWidgetFrame {\n  background: #fff;\n  border: 1px solid #e6e9ed;\n  width: 100%;\n  margin-bottom: 10px;\n  padding: 10px 17px;\n  display: inline-block;\n  position: relative;\n}\n\n.defaultWidgetFrameHeader {\n  border-bottom: 2px solid #e6e9ed;\n  height: 35px;\n  margin-bottom: 10px;\n  padding: 1px 5px 6px;\n}\n\n.defaultWidgetFrameHeader .title {\n  float: left;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 18px;\n  display: block;\n  overflow: hidden;\n}\n\n.defaultWidgetFrameHeader .remove {\n  float: right;\n  cursor: pointer;\n  margin-top: 5px;\n  font-size: 11px;\n  text-decoration: none;\n}\n\n.droppable-column {\n  background-color: #e7e7e7;\n}\n\n.dazzle-column-content-item-vertical {\n  float: none;\n  flex-direction: column;\n  margin-bottom: 10px;\n  display: flex;\n}\n\n.dazzle-column-content-item-horizontal {\n  margin: 0 10px 10px;\n  display: inline-block;\n}\n\n.dazzle-column-header {\n  -webkit-user-select: auto;\n  user-select: auto;\n  border-bottom: 2px solid #f4f4f4;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 15px;\n  padding-bottom: 10px;\n  display: flex;\n}\n\n.dazzle-column-header.grab {\n  cursor: grab;\n}\n\n@media (width >= 1200px) {\n  .dazzle-col {\n    flex-direction: column;\n    display: flex;\n  }\n}\n\n.dazzle__title-input {\n  width: auto;\n  height: 29px;\n  padding-bottom: 4px;\n}\n\n.dazzle__row-row-wrapper--over {\n  background: #ff323266;\n}\n\n.dazzle__row-row-wrapper--outline {\n  outline: 1px dashed #dcdcdc;\n}\n\n.dazzle__row-content-wrapper {\n  margin-bottom: 10px;\n}\n\n@media (width >= 1200px) {\n  .dazzle__row-content-wrapper {\n    margin-bottom: 25px;\n    display: flex;\n  }\n\n  .dazzle__row-content-wrapper--editable {\n    margin-bottom: 10px;\n  }\n}\n\n.dazzle__empty-dashboard {\n  text-align: center;\n  background-image: url(\"public/img/dashboard.png\");\n  background-position: top;\n  background-repeat: no-repeat;\n  background-size: 250px;\n  padding: 250px 0 25px;\n}\n\n.dazzle__column-wrapper {\n  border: 1px solid #f4f4f4;\n  flex: auto;\n  padding: 10px 17px;\n}\n\n.dazzle__column-title {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.dazzle__column-title.is-untitled {\n  font-style: italic;\n}\n\n.dazzle__column-content {\n  text-align: center;\n  flex-wrap: wrap;\n  justify-content: center;\n  margin-top: 10px;\n}\n\n.dazzle__add-row-wrapper {\n  cursor: pointer;\n  background: #f4f4f4;\n  border-radius: 3px;\n  justify-content: stretch;\n  align-items: stretch;\n  height: 2.2rem;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
